<template>
  <div class="formBox-contain-group">
    <div class="labeltxts">
      <div>
        <span v-if="required" class="start">*</span>{{ labeltxt ? `${labeltxt}：` : '' }}
      </div>
      <slot name="labeltxt"></slot>
    </div>
    <div class="contents"><slot></slot></div>
    <div><slot name="noContents"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'FormBoxItem',
  props: {
    labeltxt: {
      type: [String],
    },
    required: {
      type: [Boolean],
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.start {
  margin-right: 4px;
  color: red;
}

.formBox-contain-group {
  width: 100%;
  border: 1px solid $secondary;
  margin: -1px 0 0 -1px;
  background-color: $secondaryGray;

  .formBox-contain-group {
    border: unset;
  }

  .labeltxts {
    font-weight: 600;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: $secondaryGray;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
    padding-bottom: 0.25rem;
    width: 100%;

    button {
      margin-top: 0 !important;
      margin-left: 8px !important;
    }
  }
  .contents {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.25rem;
    @include pad-width() {
      max-width: none;
      width: fit-content;
    }
    span {
      max-width: 100%;
      @include pad-width() {
        max-width: none;
      }
    }

    .formBox-contents-row {
      margin: 0 !important;
    }
  }
  .contents:empty {
    display: none;
  }
  .contents:has(.v-textarea)
  {
    width: 100% !important;
  }
  .search {
    background-color: $white;
    border-radius: 28px;
  }
  .contents:has(.main__table)
  {
    width: 100% !important;
    .main__table{
      width: 100% !important;
    }
  }
}

</style>
